import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

import { Loading } from "../components/Loading";

const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout]);

  return (
    <Loading data-component="Logout" text="Bye for now! Logging you out..." />
  );
};

export default Logout;
